import log from 'salvo-lite/log'

class ChangeClass {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-change-class'))
        this._targetElem = this._data.elem || 'self'
        this._event = this._data.event || 'click'
        this._action = this._data.action || 'toggle'
        this._maxWidth = this._data.maxWidth || 9999999
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener(this._event, e => {
            if ((this._data.targetMatch && e.target === this._elem) || (!this._data.targetMatch)) {
                if (window.innerWidth <= this._maxWidth) {
                    if (Array.isArray(this._targetElem)) {
                        for (var i = 0; i < this._targetElem.length; i++) {
                            const elem = this._getElement(this._targetElem[i])
                            const className = Array.isArray(this._data.class) ? this._data.class[i] : this._data.class
                            const action = Array.isArray(this._action) ? this._action[i] : this._action
                            this._changeClass(elem, className, action)
                        }
                    } else {
                        this._changeClass(this._getElement(this._targetElem), this._data.class, this._action)
                    }
                }
            }
        })
    }

    _getElement (elem) {
        if (elem === 'self') {
            return this._elem
        } else if (elem === 'parent') {
            return this._elem.parentNode
        } else if (elem === 'next') {
            return this._elem.nextElementSibling
        } else if (elem === 'prev') {
            return this._elem.previousElementSibling
        } else {
            if (this._data.childElem) {
                return this._elem.querySelector(elem)
            } else {
                return document.querySelector(elem)
            }
        }
    }

    _changeClass (elem, className, action = 'toggle') {
        if (elem) {
            if (elem.classList.contains(className)) {
                if (action !== 'add') {
                    // console.log(elem, action, className)
                    elem.classList.remove(className)
                }
            } else {
                if (action !== 'remove') {
                    // console.log(elem, action, className)
                    elem.classList.add(className)
                }
            }

            if (this._data.siblingsRemove) {
                this._removeClassFromSiblings(elem, className)
            }
        }
    }

    _removeClassFromSiblings (elem, className) {
        const parent = elem.parentNode
        const siblings = parent.children
        for (var i = 0; i < siblings.length; i++) {
            const sibling = siblings[i]
            if (sibling !== elem) {
                sibling.classList.remove(className)
            }
        }
    }
}

export default ChangeClass



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ChangeClass.js